import { Title, Button } from '@getinapp/appetizer';
import { Dollar } from '@styled-icons/boxicons-regular/Dollar';
import { User } from '@styled-icons/boxicons-regular/User';
import { TimeFive } from '@styled-icons/boxicons-regular/TimeFive';
import * as S from './styles';
import { getPrice } from 'utils/helpers';
import { Select } from 'components/Select';
import { Event } from 'utils/helpers';
import { useRemoteLineDetails } from './hooks';
import { useCreatePayment } from 'hooks/use-create-payment';
import { useLine } from 'hooks/use-line';

export type RemoteLineDetailsProps = {
  onPressContinue: () => void;
  onSuccess?: () => void;
  onError?: () => void;
};

export const RemoteLineDetails = ({
  onPressContinue,
  onSuccess,
  onError,
}: RemoteLineDetailsProps) => {
  const { setQuantity, settings, t, unit, user } = useRemoteLineDetails();
  const { mutate } = useCreatePayment();
  const { quantity } = useLine();

  if (!settings || !unit) return null;

  const createPayment = () => {
    mutate(
      {
        name: user?.name,
        mobile: user?.mobile,
        email: user?.email,
        people: Number(quantity),
        unit_id: unit.id,
      },
      {
        onSuccess: () => onSuccess?.(),
        onError: () => onError?.(),
      }
    );
  };

  return (
    <>
      <S.Header>
        <S.Avatar src={unit.profile_image} alt={unit.name} />
        <div>
          <Title>{unit.name}</Title>
          <p>{unit.full_address}</p>
        </div>
      </S.Header>
      <S.Content>
        <S.Wrapper>
          <small>
            <span>
              <User size={25} />
            </span>
          </small>
          <div>
            <Select label={t('@RemoteLineDetails.table-for-people')}>
              <select
                onChange={(e) => setQuantity(e.target.value)}
                onClick={() => {
                  Event.push('getin_line_step1_people_click', {
                    user_id: user?.id,
                  });
                }}
              >
                <option value="" disabled selected hidden>
                  {t('@RemoteLineDetails.select')}
                </option>
                {settings.table_people.map((value) => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
              </select>
            </Select>
          </div>
        </S.Wrapper>
        {!!settings.pricing && (
          <S.Wrapper>
            <small>
              <span>
                <Dollar size={25} />
              </span>
              {t('@RemoteLineDetails.service-tax')}
            </small>
            <small>{getPrice(settings.pricing / 100)}</small>
          </S.Wrapper>
        )}
        <S.Wrapper>
          <small>
            <span>
              <TimeFive size={25} />
            </span>
            {t('@RemoteLineDetails.tables-in-line')}
          </small>
          <small>{settings.tables_in_line}</small>
        </S.Wrapper>
        <br />
        <Button onClick={settings.pricing ? onPressContinue : createPayment}>
          {t('@RemoteLineDetails.continue')}
        </Button>
      </S.Content>
    </>
  );
};
